import { TFee } from "../interfaces/configuration";
import { IAlert } from "../interfaces/alert";
import { TFeeModalAction } from "../interfaces/modal";

export interface IFeesStates {
  fees: TFee[];
  count: number;
  loading: boolean;
  alert: IAlert;
  openModal: boolean;
  selectedAction: TFeeModalAction;
  selectedFee: TFee|null;
  page: number;
}

export type TFeesAction =
  | { type: "setFees"; value: TFee[] }
  | { type: "setCount"; value: number }
  | { type: "setLoading"; value: boolean }
  | { type: "setAlert"; value: IAlert }
  | { type: "setOpenModal"; value: boolean }
  | { type: "setSelectedAction"; value: TFeeModalAction }
  | { type: "setSelectedFee"; value: TFee }
  | { type: "setPage"; value: number }

export const feesReducer = (state: IFeesStates, action: TFeesAction) => {
  switch (action.type) {
  case "setFees":
    return { ...state, fees: action.value };
  case "setCount":
    return { ...state, count: action.value };
  case "setLoading":
    return { ...state, loading: action.value };
  case "setAlert":
    return { ...state, alert: action.value };
  case "setOpenModal":
    return { ...state, openModal: action.value };
  case "setSelectedAction":
    return { ...state, selectedAction: action.value };
  case "setSelectedFee":
    return { ...state, selectedFee: action.value };
  case "setPage":
    return { ...state, page: action.value };
  default:
    return state;
  }
};
